import { ReportsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { reportsKeys } from 'app/queries/reports/reportsKeys';
import type { TCall } from 'app/queries/types/TCall';
import { buildUserJobsReportRequest } from './buildUserJobsReportRequest';

type TParams = QueryFunctionContext<ReturnType<typeof reportsKeys.userJobsList>>;

export const createFetchUserJobsReportQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ workspaceId, userId, params }], signal }: TParams) =>
    call(() =>
      cancelOnSignal(ReportsService.getUserJobsReport(buildUserJobsReportRequest(workspaceId, userId, params)), signal),
    );
